import { useEffect } from 'react';
import {
  SCORE_CONTAINER_CLASS_NAME,
  totalSlideShowScoreHtml,
} from '@/components/shared/Froala/plugins/TextVariable/TextVariablePopover/TotalSlideShowScore/TotalSlideShowScore.utils';

export const useUpdateTotalSlideShowScore = (locale: string, score: number, dependencies?: any[]) => {
  useEffect(() => {
    if (score == null) return;

    const scoreElements = document.querySelectorAll(`.${SCORE_CONTAINER_CLASS_NAME}`);
    scoreElements.forEach((element) => {
      const style = element.getAttribute('style');
      element.outerHTML = totalSlideShowScoreHtml({ locale, score, style });
    });
  }, [score, ...dependencies || []]);
};

export default useUpdateTotalSlideShowScore;
